import React from 'react';
import classnames from 'clsx';
import classes from './style/NavigationButton.scss';
import type { NavigationButtonProps } from './NavigationButton.types';

const NavigationButton: React.ForwardRefRenderFunction<
  HTMLButtonElement,
  NavigationButtonProps
> = (
  {
    className,
    onClick,
    label,
    icon,
    isDisabled = false,
    dataHook,
    ariaLabel,
    buttonType,
    dataPreview,
  },
  ref,
) => {
  return (
    <button
      ref={ref}
      onClick={onClick}
      data-hook={dataHook}
      aria-label={ariaLabel}
      disabled={isDisabled}
      className={classnames(classes.root, classes[buttonType], className)}
      data-preview={dataPreview}
    >
      <div
        data-hook={`${dataHook}-icon`}
        className={classes.icon}
        aria-hidden="true"
      >
        {icon}
      </div>
      <div className={classes.label} data-hook={`${dataHook}-label`}>
        {label}
      </div>
    </button>
  );
};

export default React.forwardRef(NavigationButton);
